module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID:
      "23144678283-oek7ncjmmrgkgmi2i56sc411gp71a8sp.apps.googleusercontent.com",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  client: {
    // production
    // Url: "https://wp.designal.cc",
    // businessNumber: "966920034242",
    // test
    Url: "https://eba-cs.designal.cc",
    FileUrl: "https://cpv-new.ams3.cdn.digitaloceanspaces.com/eba-chatplus",
    businessNumber: "966115161600",
    apiVersion: "api/v1",
    companyUuid: "063f7806-3a6a-471d-9cb5-e59df5b1d5ae",
  },
  tfiBaseUrl: "https://idi.rdapp.net/api/website",
  templateEstimatedCost: [
    {
      Market: "Egypt",
      Currency: "$US",
      Marketing: 0.0644,
      Utility: 0.0036,
      Authentication: 0.0036,
      AuthenticationInternational: 0.065,
      Service: 0,
    },
    {
      Market: "Saudi Arabia",
      Currency: "$US",
      Marketing: 0.0501,
      Utility: 0.0107,
      Authentication: 0.0107,
      AuthenticationInternational: 0.0598,
      Service: 0,
    },
    {
      Market: "United Arab Emirates",
      Currency: "$US",
      Marketing: 0.0499,
      Utility: 0.0157,
      Authentication: 0.0157,
      AuthenticationInternational: 0.051,
      Service: 0,
    },
  ],
}
